export const iconFontAwesomeCodingCodeCommit = (
	<i className="fa-solid fa-code-commit"></i>
);
